import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import getContext from 'recompose/getContext'
import withHandlers from 'recompose/withHandlers'
import lifecycle from 'recompose/lifecycle'
import pure from 'recompose/pure'

import objectEditorEnhancer from 'coact/objectEditorEnhancer'
import interceptUpdater from 'coact-utils/interceptUpdater'

import findPriceRelatedRefs from './findPriceRelatedRefs'

import ItemEditorView from './ItemEditor'

function doCountPrice (pdt1, pdt2) {
  if (pdt1 === pdt2) return false
  const { productRef, lensSpec: { s, c } = { } } = pdt1
  const { productRef: productRef2, lensSpec: { s: s2, c: c2 } = { } } = pdt2
  if ((productRef && productRef.key) !== (productRef2 && productRef2.key)) return true
  if (s !== s2 || c !== c2) return true
  return false
}

function computeSubtotal ({ unitPriceDoc, qty }) {
  if (!unitPriceDoc) return undefined
  if (typeof unitPriceDoc.price !== 'number') return undefined
  if (typeof qty !== 'number') return undefined

  return unitPriceDoc.price * qty
}

const ItemEditor = scope(
  getContext({
    server: object.isRequired,
  }),
  consumeProps({
    value: object.isRequired,
    onChange: func.isRequired,
    schema: object.isRequired,

    copy: func.isRequired,
  }),

  pure,
  objectEditorEnhancer,


  interceptUpdater('onChange', () => value => {
    const { productRef } = value
    return {
      ...value,
      productKey: productRef && productRef.key,
      productName: productRef && productRef.name,
      productType: productRef && productRef.type,
      processType: productRef && productRef.processType,
      subtotal: computeSubtotal(value),
    }
  }),


  lifecycle({
    async componentDidMount () {
      const { value, server } = this.props
      if (value.productRef) {
        const unitPriceRelatedRefs = await findPriceRelatedRefs({ value, server })
        this.props.onChange(v => ({ ...v, ...unitPriceRelatedRefs }))
      }
    },
    async componentDidUpdate (prevProps) {
      if (doCountPrice(prevProps.value, this.props.value)) {
        const { value, server } = this.props
        const unitPriceRelatedRefs = await findPriceRelatedRefs({ value, server })
        this.props.onChange(v => ({ ...v, ...unitPriceRelatedRefs }))
      }
    },
  }),


  withState('full', 'toggleFullFeatures', false),
  withHandlers({
    toggleFullFeatures: ({ toggleFullFeatures }) => () =>
      toggleFullFeatures(fullFeatures => !fullFeatures),
  }),

  withHandlers({
    copy: ({ copy }) => () => {
      const copier = ({ productRef, productType, productKey, processType }) =>
        ({ productRef, productType, productKey, processType })
      return copy({ copier })
    },
  }),

  exposeProps([
    'index',
    'value',
    'onChange',

    'schema',
    'spliter',

    'copy',
    'full',
    'toggleFullFeatures',

    'style',
  ])
)(ItemEditorView)

ItemEditor.displayName = 'ItemEditor'

export default ItemEditor



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/ItemsEditor/ItemEditor/index.js